import { useMutation } from "@apollo/client";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";

import SubmitButton from "../../../../components/common/SubmitButton";
import CustomFormGroup from "../../../../components/form/CustomFormGroup";

import { GET_MEMBER_LIST } from "../../../../graphql/queries/management";
import { handleChangeResetPassword } from "../../../management/redux/managementSlice";
import { RESET_MEMBER_PASSWORD } from "../../../../graphql/mutations/auth";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../components/common/CustomErrorMessage";

const ResetPasswordForm = ({ handleClose }) => {
  const dispatch = useDispatch();
  const management = useSelector((state) => state.management);
  const { resetPassword } = management;

  const [resetMemberPassword, { loading: loadingCreate }] = useMutation(
    RESET_MEMBER_PASSWORD,
    {
      variables: {
        member: resetPassword.member,
        newPassword: resetPassword.newPassword,
        username: resetPassword.username,
      },
      refetchQueries: [{ query: GET_MEMBER_LIST }],
      onCompleted: (data) => {
        if (data) {
          handleClose();
          showSuccessToast();
        }
      },
      onError(err) {
        showErrorToast(err.message);
      },
    },
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    resetMemberPassword();
  };

  const handleChange = (e) =>
    dispatch(
      handleChangeResetPassword({
        ...resetPassword,
        [e.target.name]: e.target.value,
      }),
    );

  return (
    <Form className="notolao" onSubmit={handleSubmit}>
      <CustomFormGroup
        label="Username"
        name="username"
        onChange={handleChange}
        type="text"
        value={resetPassword.username}
        placeholder="Username"
      />
      <CustomFormGroup
        label="ລະຫັດຜ່ານໃໝ່"
        name="newPassword"
        onChange={handleChange}
        type="text"
        value={resetPassword.newPassword}
        placeholder="ລະຫັດຜ່ານໃໝ່"
      />

      <div className="text-center">
        <SubmitButton loading={loadingCreate} />
      </div>
    </Form>
  );
};

ResetPasswordForm.propTypes = {
  handleClose: PropTypes.func.isRequired,
};

export default ResetPasswordForm;
